import { useQuery } from '@tanstack/react-query';
import { getDashboardMetrics, type DashboardMetricsResponse } from '@/lib/api/dashboard';

export function useDashboardMetrics(
  organizationId: string | undefined,
  options?: {
    days?: number;
    enabled?: boolean;
  }
) {
  return useQuery<DashboardMetricsResponse>({
    queryKey: ['dashboardMetrics', organizationId, options?.days],
    queryFn: async () => {
      if (!organizationId) throw new Error('Organization ID required');
      return getDashboardMetrics(organizationId, options?.days);
    },
    enabled: !!organizationId && (options?.enabled ?? true),
    staleTime: 30 * 1000, // Consider fresh for 30 seconds
  });
}
